module.exports = __webpack_public_path__ + "img/label-3A4.117fc886.jpeg";